import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

import styles from './Loading.module.scss';

const Loading: FC<IProps> = (props) => {
    return (
        <div className={classNames(styles.loading, props.className)}>
            <ClipLoader
                color={'#8A43FF'}
                loading={true}
                size={props.size ?? 50}
            />
        </div>
    );
};

export default Loading;
